export const quoteLevelConstants = {

    garIndicators : {
        no : 'N',
        yes : 'Y',
        ignored: 'I',
        beaten: 'B',
        featured: 'F'
    },
    maritalStatus: {
        single: 'S',
        married: 'M',
        registeredCP: 'CP',
        divorced: 'D',
        widowed: 'W',
        seperated: 'SE'
    },
    radioToggleYesNo: {
        yes: 'Y',
        no: 'N'
    }
};
